import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveFileCommand extends BaseCommand {
  CommandName = "RemoveFile";
  Command: { FileTmpId: number };
  constructor(sessionId: string, operationId: string, fileTmpId: number) {
    super(sessionId, operationId);
    this.Command = { FileTmpId: fileTmpId };
  }
}
